<template>
  <div class="weather-station-container">
    <div class="title">
      <svg-icon icon-class="device" /><span>设备情况</span>
    </div>
    <div class="weather-station shadow-card">
      <div class="sensor-container">
        <div
          v-for="(i,index) in sensorData"
          :key="i.identifier"
          :class="'position'+index"
          :style="{color:color[i.status]}"
          class="sensor-item"
        >
          <div class="name">
            {{ i.name }}
          </div>
          <div class="text">
            {{ i.value + i.unit }}
          </div>
        </div>
      </div>
      <img src="./images/weather-station.png" alt="" class="station-img">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  props: {
    sensorData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      color: ['#FF8624', '#FF3B3B']
    }
  }
}
</script>

<style lang="less" scoped>
.weather-station-container {
  margin-top: 20px;
  .title {
    span {
      position: relative;
      display: inline-block;
      font-size: 18px;
      font-weight: 500;
      color: #3D3D3D;
      z-index: 0;
      line-height: 1;
      &::after {
        content: "";
        position: absolute;
        display: block;
        bottom: 0;
        height: 4px;
        width: 100%;
        background: linear-gradient(to right, @primary-color, transparent);
        z-index: -1;
      }
    }
    .svg-icon {
      width: 24px;
      height: 24px;
    }
  }
  .weather-station {
    position: relative;
    z-index: 0;
    margin-top: 12px;
    padding: 20px;
    min-height: 400px;
  }
  .station-img {
    position: absolute;
    z-index: -1;
    width: auto;
    height: auto;
    left: 50%;
    top: 20px;
    transform: translate(-50%, 0);
  }
  .sensor-container {
    display: grid;
    grid-template-columns: 60px 60px;
    justify-content: space-between;
    align-items: flex-start;
    grid-row-gap: 20px;
    z-index: 1;
  }
  .sensor-item {
    color: @primary-color;
    font-size: 12px;
    border-radius: 2px;
    background: currentColor;
    border: 1px solid currentColor;
    overflow: hidden;
    .name {
      padding: 2px 6px;
      text-align: center;
      color: #fff;
    }
    .text {
      flex-grow: 1;
      padding: 6px;
      text-align: center;
      background: #fff;
      font-weight: 500;
      color: #3D3D3D;
    }
  }
  .position0 {
    top: 30px;
    left: -10px;
  }
  .position1 {
    left: -10px;
    top: 125px;
  }
  .position2 {
    left: -10px;
    top: 190px;
  }
  .position3 {
    left: -10px;
    bottom: 40px;
  }
  .position4 {
    right: -10px;
    top: 30px;
  }
  .position5 {
    right: -10px;
    top: 130px;
  }
  .position6 {
    right: -10px;
    top: 230px;
  }
  .position7 {
    right: -10px;
    top: 200px;
  }
}
.shadow-card {
  background-color: #FFFFFF;
  box-shadow: 0 4px 12px 1px rgba(205, 205, 205, 0.2);
  border-radius: 12px;
  overflow: hidden;
}
</style>
